
// import barba from '@barba/core';

export default class{

	constructor(){

        // barba.hooks.once((data) => {
        //     this.init()
        // })
        // barba.hooks.after((data) => {
        //     this.init()
        // });
        this.init()
    }
    init (){
        
        var megamenu = document.querySelectorAll('.megamenu__wrapper');
        var megamenuNav = [];
        var megamenuPanes = [];
        if(megamenu.length > 0){
            for(var i = 0; i < megamenu.length; i ++){
                megamenuNav = megamenu[i].querySelectorAll('.flex--menu__trigger');
                megamenuPanes = megamenu[i].querySelectorAll('.flex--menu__panel');
                if(megamenuNav.length > 0){
                    for(var j = 0; j < megamenuNav.length; j ++){
                        if(j == 0){
                            megamenuNav[0].classList.add('active');
                            megamenuPanes[0].classList.add('active');
                            // var anchor = document.querySelector( megamenuNav[0].getAttribute('href') );
                            // if ( !anchor ) return;
                            // anchor.classList.add('active');
                        }
                        _addEvent(megamenuNav[j],j,megamenuNav,i);
                    }
                }
            }
        }
        function _addEvent(el,k,megamenuNav,i){
            el.addEventListener('mouseenter',function(e){
                //e.preventDefault();
                megamenuHide(i);
                el.classList.add('active');

                //console.log(megamenuPanes[k]);
                megamenuPanes[k].classList.add('active');

                // var event = new CustomEvent("resize")
                // window.dispatchEvent(event)
            })
        }
        function megamenuHide(i){
            var navActive = megamenu[i].querySelector('.flex--menu__trigger.active');
            var megamenuActive = megamenu[i].querySelector('.flex--menu__panel.active');
            if(navActive){
                navActive.classList.remove('active');
            }
            if(megamenuActive){
                megamenuActive.classList.remove('active');
            }
        }		
    }	
}